module.exports = __webpack_public_path__ + "img/verification-faild.8145b50b.png";